// extracted by mini-css-extract-plugin
export var bodySections = "_48-8";
export var gray = "_48-7";
export var green = "_48-4";
export var iconContainer = "_48-9";
export var iconWidgetContainer = "_48-1";
export var phoneIcon = "_48-2";
export var red = "_48-5";
export var statusDot = "_48-3";
export var widgetContainer = "_48-0";
export var yellow = "_48-6";